module.exports = __webpack_public_path__ + "img/blog.dad8bf07.jpg";